module.exports = __webpack_public_path__ + "img/deux-battants.15a3ba1.svg";